import { useCallback, useRef, useState } from "react";

const InfiniteScroll = ({
  className = "",
  next,
  hasMore,
  loader,
  endMessage,
  children,
  dataLength,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const observer = useRef(null);

  const lastElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (dataLength == 0) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setIsLoading(true);
          next().finally(() => {
            setIsLoading(false);
          });
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataLength]
  );

  return (
    <div className={className}>
      {children}
      <div ref={lastElementRef}></div>
      {isLoading && loader}
      {!hasMore && endMessage}
    </div>
  );
};

export default InfiniteScroll;
